// src/components/admin/Category/LogsTab.jsx
export default function LogsTab() {
    return (
      <div>
        <h2 className="text-lg font-semibold mb-2">Category Logs</h2>
        <p>Activity logs and history will be shown here. (Coming soon)</p>
      </div>
    );
  }
  